import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'radius-top-right', 'RadiusTopRight', [["path",{"d":"M5 5h6a8 8 0 0 1 8 8v6"}]]);